module.exports = __webpack_public_path__ + "static/media/post-office.c72dc597.svg";